import { useState } from "react";
// redux
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/reducers";
//  api services
import apiParticipantes from "../api/Participantes/api-participantes";
// route
import { useNavigate } from "react-router";
import { initialValuesPostulacionModel } from "../models/PostulacionesModel/postulacion.model";
import { openNotification } from "../utils/Notifactions";
import { Convocatoria } from "../models/ConvocatoriasModel/convocatoria.model";
import {
  guardarDatosPostulacion,
} from "../redux/actions/participantesAction";
import { useEncrypt } from "./useEncrypt";
import getStorageUser from "../middlewares/GetStorageUser"
import { ObjNotificaciones } from "../config/notificaciones";

export const useAgregarurl = () => {
  // route
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { decrypt } = useEncrypt();
  // redux
  const { datos_postulacion } = useSelector(
    (state: RootState) => state.participantes
  );
  // const { idParticipante } = useSelector((state: RootState) => state.participantes);
  // state
  const [nombrepropuesta, setNombrepropuesta] = useState<string>("");
  const [url, setUrl] = useState<string>("");
  const [urls, setUrls] = useState<Array<any>>([]);
  const [modal, setModal] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [loading, setLoading] = useState(false);

  const [selBefore, setSeltBefore] = useState<string>("http://");
  const [selAfter, setSeltAfter] = useState<string>(".com");

  const handelSelectChacnge = (e: any, tipo: string) => {
    if (tipo == "selectBefore") {
      return setSeltBefore(e);
    } else if (tipo == "selectAfter") {
      return setSeltAfter(e);
    }
  };

  const cambiarnombrepropuesta = (e: any) => {
    return setNombrepropuesta(e.target.value);
  };

  const cambiarurl = (e: any) => {
    return setUrl(e.target.value);
  };

  const agregarurl = () => {
    if (url === "") {
      return openNotification({
        titulo: "Error",
        descripcion: "Por favor digite una URL",
        placement: "bottomRight",
      });
    }

    if (/^(ftp|http|https):\/\/[^ "]+$/.test(url)) {
      //console.log("entra");
      setUrls([...urls, { index: urls.length - 1, url: `${url}` }]);
      return setUrl("");
    } else {
      return openNotification({
        titulo: "Error",
        descripcion: "No es una estructura de URL valida (Recuerda que debe iniciar en 'https://www')",
        placement: "bottomRight",
      });
    }
  };

  const eliminarurl = (index: number) => {
    let infoupdate = [...urls];
    infoupdate = infoupdate.filter((data: any, i: number) => i !== index);
    infoupdate = infoupdate.map((data: any, i: number) => {
      return {
        ...data,
        index: i,
      };
    });
    //console.log(infoupdate);
    return setUrls(infoupdate);
  };

  const [postulacion, setPostulacion] = useState<any>(
    initialValuesPostulacionModel
  );

  const [nombreParticipante, setNombreParticipante] = useState<any>({});

  const getPostulacion = async () => {
    try {
      // console.log(postulacion)
      const { data } = await apiParticipantes.consultarPostulacion(
        decrypt(localStorage.getItem("id_postulacion"))
      );
      // const postulacion = await apiParticipantes.consultarPostulacionConCreador(id_postulacion);
      //console.log(postulacion.data[0]);
      setNombreParticipante(postulacion.data[0]);

      return setPostulacion(data);
    } catch (error) { }
  };

  const guardarurl = async () => {
    try {
      // await apiParticipantes.actualizarNombrePropuesta(id_postulacion, nombrepropuesta);
      // await apiParticipantes.guardarLinksPostulacion(id_postulacion, urls);
      return;
    } catch (error) {
      return console.error(error);
    }
  };

  const [postulacionId,] = useState(0);
  const crearPostulacion = async (
    convocatorias: Convocatoria,
    userProps: string
  ) => {
    const user = getStorageUser()

    // let notificacionCorreo = {
    //   tipo_participante: 1,
    //   tipo_notificacion: "inscripción",
    //   remitente: user.documento,
    //   convocatoria_id: decrypt(
    //     localStorage.getItem("idConvocatoriaPostulacion")
    //   ),
    // };
    // await apiNotificaciones.enviarNotificacion(notificacionCorreo);
    await apiParticipantes.actualizarNombrePropuesta(
      decrypt(localStorage.getItem("id_postulacion")),
      nombrepropuesta
    );
    await apiParticipantes.guardarLinksPostulacion(
      decrypt(localStorage.getItem("id_postulacion")),
      urls
    );

    let nombre_postulado = `${user.nombres} ${user.apellidos}`;
    setNombreParticipante(nombre_postulado);

    const { data: postulacion1 } =
      await apiParticipantes.consultarPostulacionConCreador(
        user.documento,
        decrypt(localStorage.getItem("id_postulacion"))
      );
    localStorage.removeItem("id_postulacion");

    return setPostulacion(postulacion1[0]);
    // dispatch(idPostulacion(data.id_postulacion));
    // await apiParticipantes.guardarDocumentosAdministrativosPostulacion(
    //   data.id_postulacion,
    //   convocatorias.documentos_administrativos
    // );
    // await apiParticipantes.guardarDocumentosTecnicosPostulacion(data.id_postulacion, convocatorias.documentos_tecnicos);
    // await apiParticipantes.guardarDocumentosGeneralesPostulacion(
    //   data.id_postulacion,
    //   convocatorias.documentos_generales
    // );

    // await apiParticipantes.cambiarTipoParticipante(data.id_postulacion, datos_postulacion.principalState.tipo_participante);
    // await apiParticipantes.actualizarCategoriasPropuesta(data.id_postulacion, datos_postulacion.categoriaPropuesta);

    // await apiParticipantes.guardarDocumentosAdministrativosPostulacion(
    //   data.id_postulacion,
    //   datos_postulacion.documentos_administrativos
    // );

    // await apiParticipantes.guardarDocumentosTecnicosPostulacion(data.id_postulacion, datos_postulacion.documentosTecnicos);

    // const postulacion1 = await apiParticipantes.consultarPostulacion(data.id_postulacion);

    // console.log(postulacion2, 'es aqui X10')

    // dispatch(idPostulacion(data.id_postulacion));

    // setNombreParticipante(postulacion2.data[0])
  };

  // const [openModal, setOpenModal] = useState(false);
  const continuarurl = async (guardar?: boolean) => {
    console.log("Hola a guardar");
    
    const id_postulacion = decrypt(localStorage.getItem("id_postulacion"));

    if (nombrepropuesta === "") {
      return openNotification({
        titulo: "Error",
        descripcion: "Por favor digite el nombre de la propuesta",
        placement: "bottomRight",
      });
    }
    try {
      setDisableButton(true);
      setLoading(true);
      const user = getStorageUser()
      const { data } = await apiParticipantes.consultarIdParticipante(
        user.documento
      );
      await crearPostulacion(
        datos_postulacion.convocatorias,
        data.id_Participante
      );

      if (guardar) {
        await apiParticipantes.actualizarEstadoPostulacionArtista(id_postulacion, "Por completar");
        ObjNotificaciones.MSG_SUCCESS("¡Guardado!", "Se ha guardado la información correctamente");
        return navigate("/Usuario");
      } else {
        // await apiParticipantes.actualizarNombrePropuesta(id_postulacion, nombrepropuesta);
        // await apiParticipantes.guardarLinksPostulacion(id_postulacion, urls);
        setOpenModal(true);

        setModal(true);

        await apiParticipantes.actualizarEstadoPostulacionArtista(id_postulacion, "Inscrito sin revisar");

        setLoading(false);
        return;
      }

    } catch (error) {
      setLoading(false);
      return console.error(error);
    }
  };

  const AceptarModal = () => {
    dispatch(guardarDatosPostulacion({}));
    setModal(false);
    return navigate("/usuario/");
  };

  return {
    nombrepropuesta,
    url,
    setUrl,
    urls,
    setUrls,
    cambiarnombrepropuesta,
    cambiarurl,
    agregarurl,
    eliminarurl,
    guardarurl,
    continuarurl,
    modal,
    AceptarModal,
    setModal,
    getPostulacion,
    postulacion,
    openModal,
    setOpenModal,
    nombreParticipante,
    postulacionId,
    handelSelectChacnge,
    selBefore,
    selAfter,
    disableButton,
    loading,
  };
};
